import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import LinesSection from './components/LinesSection';
import Problem from './components/Problem';
import Features from './components/Features';
import Nano from './components/Nano';
import Footer from './components/Footer';
import Manifesto from './components/Manifesto';
import Privacy from './components/Privacy';
import Terms from './components/Terms';

function HomePage() {
  return (
    <>
      <Header />
      <Hero />
      <LinesSection 
        purpleCount={4} 
        purpleSpacing={4} 
        startPosition={15} 
        gap={25} 
      />
      <LinesSection 
        purpleCount={2} 
        purpleSpacing={10} 
        startPosition={15} 
        gap={27}
        questions={[
          "What could you build instead of the tools you're renting?",
          "What would it cost to replace them with software built for exactly how you work?"
        ]}
      />
      <Problem />
      <Features />
      <Nano />
      <Footer />
    </>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/manifesto" element={<Manifesto />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
        </Routes>
    </div>
    </Router>
  );
}

export default App;

